import { Modal } from 'react-bootstrap';
import React from 'react';
import './CustomModal.css';
import Terms from '../../components/Terms/Terms';

// 合材管理ダッシュボードでは利用規約(/Terms)モーダルのみ使用する。
// その他の WebEdition 用モーダル（ルート/エリア/端末/各種設定 等）は本アプリの設計対象外のため削除。
export default function VerticallyCenteredModal(props: any) {

    function getBody() {
        if (props.path === '/Terms') {
            return (<Terms onNavi={props.onNavi} termsText={props.data.termsText} userRoleId={props.data.userRoleId} />);
        }
        return (<div></div>);
    }

    function onShow() {
        let dialog: any = document.querySelector('[role="dialog"]');
        if (dialog) dialog.oncontextmenu = () => false;
    }

    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName={props.data.sizeFitContent ? "" : "modal-full"}
            centered
            show={props.show}
            onHide={() => props.onHide()}
            onShow={() => onShow()}
        >
            <Modal.Body>
                {getBody()}
            </Modal.Body>
        </Modal>
    );
}
